'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _grid = require('../components/grid.directive');

var _grid2 = _interopRequireDefault(_grid);

var _tenant = require('../api/tenant.service');

var _tenant2 = _interopRequireDefault(_tenant);

var _contact = require('../components/contact.directive');

var _contact2 = _interopRequireDefault(_contact);

var _contactShort = require('../components/contact-short.filter');

var _contactShort2 = _interopRequireDefault(_contactShort);

var _tenant3 = require('./tenant.routes');

var _tenant4 = _interopRequireDefault(_tenant3);

var _tenant5 = require('./tenant.controller');

var _tenant6 = _interopRequireDefault(_tenant5);

var _tenant7 = require('./tenant.directive');

var _tenant8 = _interopRequireDefault(_tenant7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
exports.default = angular.module('thingsboard.tenant', [_angularUiRouter2.default, _grid2.default, _tenant2.default, _contact2.default, _contactShort2.default]).config(_tenant4.default).controller('TenantController', _tenant6.default).directive('tbTenant', _tenant8.default).name;


// WEBPACK FOOTER //
// ./src/app/tenant/index.js